import React from 'react';
import '../styles/HighlighterBanner.css';

const HighlighterBanner: React.FC = () => {
  return (
    <div className="highlighter-banner">
      <div className="container">
        <div className="highlighter-content">
          <span className="highlighter-text">
            Need expert support or have a project in mind?
          </span>
          <span className="highlighter-cta">
            Connect with your nearest WTIL representative – &nbsp;
            <a href="/contact" className="highlighter-link">
              Click here to reach us
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default HighlighterBanner;
